// components
import ContentLayout from "@/layouts/ContentLayout";
import TextBlock from "@/components/blocks/TextBlock";
import TitleBanner from "@/components/banners/TitleBanner";

// assets
import banner from "@/assets/images/about-us/about-planetrus/banner.png";
import image1 from "@/assets/images/about-us/about-planetrus/image1.png";
import image2 from "@/assets/images/about-us/about-planetrus/image2.jpg";

// i18n
import { useTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa";

const AboutPlanetrus = () => {
  const { t } = useTranslation();

  const data = [
    {
      title: "our_mission",
      descriptions: ["our_mission_description_1", "our_mission_description_2", "our_mission_description_3"],
    },
    {
      title: "the_need_for_change",
      descriptions: [
        "the_need_for_change_description_1",
        "the_need_for_change_description_2",
        "the_need_for_change_description_3",
        "the_need_for_change_description_4",
      ],
    },
    {
      title: "our_team",
      descriptions: [
        "our_team_description_1",
        "our_team_description_2",
        "our_team_description_3",
        "our_team_description_4",
      ],
    },
  ];

  return (
    <div className="w-full">
      <TitleBanner bannerImg={banner} title={t("about_us.about_planetrus")} />
      <ContentLayout>
        {/* <article className="flex w-full flex-col gap-6">
          {data.map((item, index) => (
            <TextBlock key={index} title={item.title} descriptions={item.descriptions} translationKey="about_us" />
          ))}
        </article> */}
        <article className="rtl-row-reverse flex w-full flex-col gap-6 lg:flex-row">
          <TextBlock title={data[0].title} descriptions={data[0].descriptions} translationKey="about_us" />
          <figure className="mt-6 flex h-[400px] w-full items-center justify-center overflow-hidden lg:mt-12">
            <img src={image1} alt="about-us-image1" className="w-full object-cover" />
          </figure>
        </article>
        <article className="rtl-row-reverse mt-9 flex w-full flex-col-reverse gap-6 md:flex-row md:gap-8 lg:gap-12">
          <figure className="w-full min-h-[200px] max-h-[400px] overflow-hidden md:min-h-[300px] md:max-h-[400px] md:w-1/2">
            <img
              src={image2}
              alt="about-us-image2"
              className="h-full w-full object-cover"
              style={{ aspectRatio: "16/9" }}
            />
          </figure>
          <div className="w-full md:w-1/2 flex items-center">
            <TextBlock
              title={data[1].title}
              descriptions={data[1].descriptions}
              translationKey="about_us"
            />
          </div>
        </article>

        <article className="mt-6 flex w-full flex-col gap-6">
          <TextBlock title={data[2].title} descriptions={data[2].descriptions} translationKey="about_us" />
        </article>
        <button
          className="mt-6 flex items-center rounded-md bg-primary px-6 py-3 text-base font-bold text-white"
          onClick={() => window.open("/about-us/meet-our-team", "_self")}
        >
          {t("home.read_more")} <FaArrowRight className="rtl-icon-flip" style={{ marginInlineStart: "0.5rem" }} />
        </button>
        {/* <figure className="mt-9 h-fit w-full overflow-hidden rounded-lg">
          <img src={image1} alt="about-us-image1" className="w-full object-cover" />
        </figure> */}
      </ContentLayout>
    </div>
  );
};

export default AboutPlanetrus;
